export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13751.098af482.jpg";